import React from 'react';
import { Building2, BookOpen, FolderClosed } from 'lucide-react';
import clockImg from '@/assets/team-icons/clock.png';
import inspectionsImg from '@/assets/team-icons/inspections.png';
import vehiclesImg from '@/assets/team-icons/vehicles.png';
import pmpImg from '@/assets/team-icons/pmp.png';
import communicationImg from '@/assets/team-icons/communication.png';
import trainingImg from '@/assets/team-icons/training.png';
import suppliesImg from '@/assets/team-icons/supplies.png';
import myInfoImg from '@/assets/team-icons/my-information.png';

// Eight TEAM function icons supplied as transparent PNG artwork. Rendered as-is:
// native proportions preserved, no crop/recolor/background/frame/shadow. Shared by
// mobile + desktop and English + Spanish via the `size` prop.
const BLUE = '#1C4FC9';
const NAVY = '#0E2A47';
const GREEN = '#5FA718';

const makeIcon = (src, alt) => {
  const Icon = ({ size = 40, className }) => (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      draggable={false}
      className={`object-contain ${className || ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    />
  );
  Icon.displayName = `TeamIcon(${alt})`;
  return Icon;
};

export const ClockIcon = makeIcon(clockImg, 'Clock In / Out');
export const InspectionsIcon = makeIcon(inspectionsImg, 'Inspections');
export const VehicleIcon = makeIcon(vehiclesImg, 'Vehicles');
export const MaintenanceIcon = makeIcon(pmpImg, 'Preventive Maintenance');
export const CommunicationIcon = makeIcon(communicationImg, 'Communication');
export const TrainingIcon = makeIcon(trainingImg, 'Training');
export const SuppliesIcon = makeIcon(suppliesImg, 'Supplies');
export const MyInfoIcon = makeIcon(myInfoImg, 'My Information');

// Property Updates uses a lucide glyph (no PNG asset) tinted in TEAM blue so it
// reads clearly alongside the supplied artwork at any size.
export const PropertyIcon = ({ size = 40, className }) => (
  <Building2 size={size} strokeWidth={1.75} className={className} style={{ color: BLUE }} aria-hidden="true" />
);
PropertyIcon.displayName = 'TeamIcon(Property Updates)';

export const ResourcesIcon = ({ size = 40, className }) => (
  <BookOpen size={size} strokeWidth={1.75} className={className} style={{ color: BLUE }} aria-hidden="true" />
);
ResourcesIcon.displayName = 'TeamIcon(Employee Resources)';

// Safety Data Sheets — red binder/document to mirror the physical yellow-and-red SDS binder.
export const SdsIcon = ({ size = 40, className }) => (
  <FolderClosed size={size} strokeWidth={2} className={className} style={{ color: '#B91C1C' }} aria-hidden="true" />
);
SdsIcon.displayName = 'TeamIcon(Safety Data Sheets)';

export const TEAM_ICONS = {
  clock: ClockIcon, inspections: InspectionsIcon, property: PropertyIcon, vehicle: VehicleIcon,
  maintenance: MaintenanceIcon, communication: CommunicationIcon, training: TrainingIcon,
  supplies: SuppliesIcon, my_info: MyInfoIcon, resources: ResourcesIcon, sds: SdsIcon,
};

export const TEAM_COLORS = { BLUE, NAVY, GREEN };
